import { render, staticRenderFns } from "./HasTerrace.vue?vue&type=template&id=4854ea0a&"
import script from "./HasTerrace.vue?vue&type=script&lang=ts&"
export * from "./HasTerrace.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports